import common from '@/store/modules/common';

export default {
    common,
};
